import { Eye, EyeOff } from '@untitledui/icons';
import { useId, useRef, useState, type InputHTMLAttributes } from 'react';

export function PasswordField({
  label,
  id: providedId,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label: string;
}) {
  const generatedId = useId();
  const id = providedId ?? generatedId;
  const inputRef = useRef<HTMLInputElement>(null);
  const [visible, setVisible] = useState(false);
  const action = visible ? 'Hide password' : 'Show password';

  return (
    <label htmlFor={id}>
      {label}
      <span className="password-field">
        <input ref={inputRef} id={id} type={visible ? 'text' : 'password'} {...props} />
        <button
          className="password-visibility"
          type="button"
          aria-label={action}
          aria-pressed={visible}
          onMouseDown={(event) => event.preventDefault()}
          onClick={() => setVisible((current) => !current)}
        >
          {visible ? (
            <EyeOff aria-hidden className="size-5" />
          ) : (
            <Eye aria-hidden className="size-5" />
          )}
        </button>
      </span>
    </label>
  );
}
